// extracted by mini-css-extract-plugin
module.exports = {"container":"heading_container__1Zh1B"};